import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  MESSAGE_COUNT_LIST_START: "MESSAGE_COUNT_LIST_START",
  MESSAGE_COUNT_LIST_SUCCESS: "MESSAGE_COUNT_LIST_SUCCESS",
  MESSAGE_COUNT_LIST_FAILED: "MESSAGE_COUNT_LIST_FAILED"
};

// ============================================ Actions ========================================================

export const messageCountListStart = data => ({
  type: actionType.MESSAGE_COUNT_LIST_START,
  payload: data
});

export const messageCountListSuccess = data => ({
  type: actionType.MESSAGE_COUNT_LIST_SUCCESS,
  payload: data
});

export const messageCountListFailed = data => ({
  type: actionType.MESSAGE_COUNT_LIST_FAILED,
  payload: data
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null
};

export default function messageCountListReducer(state = INIT_STATE, action) {
  switch (action.type) {    
    case actionType.MESSAGE_COUNT_LIST_START:
      return {
        ...state,
        loading: true
      };

    case actionType.MESSAGE_COUNT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case actionType.MESSAGE_COUNT_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================
export function* messageCountListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        messageCountListSuccess({data: response.data.data.allMessages.Messages, totalCount: response.data.data.allMessages.totalCount})
      );
    } else {
      messagePopup("", "Message Api failed", "error");
      yield put(messageCountListFailed("Message Api failed"));
    }
  } catch (error) {
    messagePopup("", "Message Api failed", "error");
    yield put(messageCountListFailed("Message Api failed"));
  }
}

export function* watchMessageCountListSaga() {
  yield takeEvery(actionType.MESSAGE_COUNT_LIST_START, messageCountListSaga);
}